import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
export class HamletResponseModel extends GlobalResponseObject {
    data?: any;
    response: any[];
}